import gql from 'graphql-tag';

import { FRAGMENT_RESPONSE_SET } from './ResponseSetFragment';

export const FRAGMENT_DROPDOWNLIST = gql`
  fragment dropDownListConf on DropDownList {
    description
    id
    responseSet {
      ...ResponseSetFragment
    }
    messages {
      correct
      incomplete
      incorrect
    }
    __typename
  }
  ${FRAGMENT_RESPONSE_SET}
`;
